  <template>
    <div class="animated fadeIn">     
           
       <!--<b-breadcrumb><h4>My Collections</h4></b-breadcrumb>-->
 


        <!--- Card Start -->
        <div v-for="collections in collection_list" class="col-md-12 " style="float: left;margin-bottom: 15px;margin-top: 10px;" >
          <b-card-group deck >
            
              <b-card class="design_card" header-tag="header" >
                <template v-slot:header>
                  <div class="col-md-12" style="padding-left: 0px;">

                <h6 class="mb-0">
                    <a class="">{{collections.collection_title}}</a>
                 
                      <i @click="openCollectionModal(collections.collection_id,collections.collection_title)" title='Edit Collection' class="fa fa-pencil icons font-1xl d-block pull-right pointer"></i>
                 
                </h6>      
                          
                  
                  </div>

                </template>

                <b-card-text style='min-height:250px;' v-if="collections.design_list.length >0"> 
                <br/>
                  <div class="col-md-12"><b>Sub Collections</b></div>


                <!-- code for table -->
                  
<div class="col-md-12">                    
<table role="table" aria-busy="false" aria-colcount="4" class="table b-table table-bordered b-table-stacked-md" id="__BVID__26" aria-describedby="__BVID__26__caption_">
   <!----><!---->
   <thead role="rowgroup" class="">
      <!---->
      <tr role="row">
         <th role="columnheader" scope="col" aria-colindex="1" class="">Sr No</th>
         <th role="columnheader" scope="col" aria-colindex="2" class="">Sub Collection Title</th>
         <th role="columnheader" scope="col" aria-colindex="3" class="">Brand</th>
         <th role="columnheader" scope="col" aria-colindex="3" class="">Category/Sub Category</th>
         <th role="columnheader" scope="col" aria-colindex="3" class="">Created Date</th>
         <th role="columnheader" scope="col" aria-colindex="4" class="">Action</th>
      </tr>
   </thead>
   <!---->
   <tbody role="rowgroup" class="">
      <!---->
      <tr role="row" class="">
         <td role="cell" aria-colindex="1" data-label="DESIGN" class="">
            <div>1</div>
         </td>

         <td role="cell" aria-colindex="1" data-label="DESIGN" class="">
            <div>Sub Collection 1</div>
         </td>
         <td role="cell" aria-colindex="1" data-label="DESIGN" class="">
            <div>Babyhug Consumables</div>
         </td>

         <td role="cell" aria-colindex="2" data-label="REQUESTED SAMPLE" class="">
            <div>Free Sample Category/Free Samples</div>
         </td>
         <td role="cell" aria-colindex="4" data-label="STATUS" class="">
            <div>22nd July 2020 10:00 AM</div>
         </td>
        <td role="cell" aria-colindex="4" data-label="STATUS" class="">
            <div>
              <i title="Edit Collection" class="fa fa-pencil icons  pointer"></i> | 
              <i title="View" class="fa fa-eye icons pointer"></i> |
              <router-link to="/designs_list"  title="Designs">
                <i title="Designs" class="fa fa-picture-o icons pointer"></i>
              </router-link>
            </div>

         </td>         
      </tr>
      <tr role="row" class="">
         <td role="cell" aria-colindex="1" data-label="DESIGN" class="">
            <div>2</div>
         </td>

         <td role="cell" aria-colindex="1" data-label="DESIGN" class="">
            <div>Sub Collection 1</div>
         </td>
         <td role="cell" aria-colindex="1" data-label="DESIGN" class="">
            <div>Babyhug Consumables</div>
         </td>

         <td role="cell" aria-colindex="2" data-label="REQUESTED SAMPLE" class="">
            <div>Free Sample Category/Free Samples</div>
         </td>
         <td role="cell" aria-colindex="4" data-label="STATUS" class="">
            <div>22nd July 2020 10:00 AM</div>
         </td>
        <td role="cell" aria-colindex="4" data-label="STATUS" class="">
            <div>
              <i title="Edit Collection" class="fa fa-pencil icons  pointer"></i> | 
              <i title="View" class="fa fa-eye icons pointer"></i> |
              <router-link to="/designs_list"  title="Designs">
                <i title="Designs" class="fa fa-picture-o icons pointer"></i>
              </router-link>
            </div>

         </td>         
      </tr>
       <!----><!---->
   </tbody>
</table>                   
</div>                        
                    
                        
                 <!-- code for table ends -->


                  


                </b-card-text>

                 <b-card-text style='min-height:250px;' v-if="collections.design_list.length <=0"> 
                    <div style="width:100%;float:left">
                    <div style="margin-top:30%;text-align:center">
                        <b-button title="Add New Design" @click="openDesignModal(collections.collection_id)" variant="primary" aria-pressed="true" class="fa fa-plus-circle fa-5x"> Add Sub Collectio</b-button>
                    </div>
                    </div>
                </b-card-text>

                <template v-slot:footer>
                 <span class="mb-0">{{collections.design_list.length }} Collection(s)
                  <b-col class='col-md-1' style="float:right;text-align:right">
                    <span @click="openDesignModal(collections.collection_id)"> 
                      <i title='Add New Design' class=" pointer fa fa-plus icons font-1xl d-block "></i>
                    </span>
                  </b-col>
                  </span>
                </template>

              </b-card>
              

          </b-card-group>
        </div>
        <!--- Card End -->

       



  <!-- Add Collection Model -->
  <b-modal size="lg" title="New Collection" v-model="addCollection" @ok="addCollection = false">
      <b-row>
    
      <b-col class='col-md-12'>
        
        <b-form name="collectionform" @submit.prevent="collectionForm('collectionform')" >
            <b-col sm="12">
              <div class="row">
                <label for="name">Collection Title</label>
                <b-form-input type="text" id="collection_title" name="collection_title" v-model="collection_title"   placeholder="Please enter your title."></b-form-input>
              </div>


              <div class="row">
                
                <div class="row">

                  <div style="margin-top:10px;" class="col-md-12"><b>Critical Path</b></div>

                  <div class="col-md-12">
                      <table role="table" aria-busy="false" aria-colcount="4" class="table b-table table-bordered b-table-stacked-md" id="__BVID__26" aria-describedby="__BVID__26__caption_">
                        <thead role="rowgroup" class="">
                              <!---->
                          <tr role="row">
                             <th role="columnheader" scope="col" aria-colindex="1" class="">Action</th>
                             <th role="columnheader" scope="col" aria-colindex="1" class="">TAT</th>
                          </tr>   
                        </thead>  
                        <tbody>
                          <tr>
                            <td role="cell" aria-colindex="2">Design Creation</td>
                            <td role="cell" aria-colindex="2">
                              <b-form-input type="text" id="collection_title1" name="collection_title1" v-model="collection_title1"   ></b-form-input>
                            </td>
                          </tr>
                          <tr>
                            <td role="cell" aria-colindex="2">Upload Pic</td>
                            <td role="cell" aria-colindex="2">
                              <b-form-input type="text" id="collection_title1" name="collection_title1" v-model="collection_title1"   ></b-form-input>
                            </td>
                          </tr>
                          <tr>
                            <td role="cell" aria-colindex="2">Upload Tech Pack</td>
                            <td role="cell" aria-colindex="2">
                              <b-form-input type="text" id="collection_title1" name="collection_title1" v-model="collection_title1"   ></b-form-input>
                            </td>
                          </tr>
                          <tr>
                            <td role="cell" aria-colindex="2">Upload Measurement Sheet</td>
                            <td role="cell" aria-colindex="2">
                              <b-form-input type="text" id="collection_title1" name="collection_title1" v-model="collection_title1"   ></b-form-input>
                            </td>
                          </tr>


                        </tbody>
                      </table>

                  </div>
                </div>  

              </div>

            </b-col>
            <div slot="footer"  style="margin-top:20px">
            
              <b-button type="submit" variant="primary" class="px-4" block>Create Collection</b-button>

            </div>
         </b-form>
      </b-col>

    </b-row>
    </b-modal>
  <!-- Add Collection Model Ends-->




  <!-- Update Collection Model -->
  <b-modal title="Update Collection" v-model="updateCollection" @ok="updateCollection = false">
      <b-row>
    
      <b-col sm="12" class='col-md-12'>
        
        <b-form name="updatecollectionform" @submit.prevent="updateCollectionDetail('updatecollectionform')" >
            <b-col sm="12">
              <div class="col-md-12">
                <label for="name">Name Your Collection</label>
                <b-form-input type="text" id="collection_title_edit" name="collection_title_edit" v-model="collection_title_edit"   placeholder="Please enter your title."></b-form-input>
              </div>
            </b-col>
            <div slot="footer"  style="margin-top:20px">
            
              <b-button type="submit" variant="primary" class="px-4" block>Update Collection</b-button>

            </div>
         </b-form>
      </b-col>

    </b-row>
    </b-modal>
  <!-- Update Collection Model Ends-->


  <!-- Add Sample Model -->
  <b-modal title="New Sub Collection" v-model="addDesignModal" @ok="addCollection = false">
      <b-row style="width:100%">
    <b-form style="width:100%" name="designform" @submit.prevent="AddDesign('designform')" >
      <b-col sm="12" md="12" style="width:100%">
        <b-card show-footer>
          <b-col sm="12">
              <b-form-group>
                <label for="name">Sub Colection Title</label>
                <b-form-input type="text" id="name" v-model="Design_Name"></b-form-input>
              </b-form-group>
            <b-form-group >
                <label for="name">Select Brand</label>
                <b-form-select id="month1"
                  :plain="true"
                  
                  :options="collection_brand">
                </b-form-select>
              </b-form-group>              

              <b-form-group >
                <label for="name">Select Category</label>
                <b-form-select id="month1"
                  :plain="true"
                  v-model="collection_category"
                  :options="categoryoptions">
                </b-form-select>
              </b-form-group>
              <b-form-group >
                <label for="name">Select Sub Category</label>
                <b-form-select id="month1"
                  :plain="true"
                  v-model="collection_subcategory"
                  :options="subcategoryoptions">
                </b-form-select>
              </b-form-group>
             
            </b-col>
          <div slot="footer">
          <!-- <b-button type="submit" variant="primary" class="px-4" block>Create Collection</b-button> -->

            <b-button type="submit" style="float:right" variant="primary"  class="px-4" block>Create Design</b-button>
          </div>
        </b-card>
         
      </b-col>
      </b-form>
    </b-row>
     </b-modal>
  <!-- Add Sample Model Ends-->


  
  <!--- Add Collection Button -->
  <div id="mybutton">
    
   <b-col  sm="4" md="2" xl class="mb-3 mb-xl-0">
    <b-button title="Add New Collection" @click="addCollection = true" variant="danger" aria-pressed="true" class="fa fa-plus-circle fa-5x pointer"></b-button>

  </b-col>

  </div>

  </div>





</template>


<style >

/*.modal-content { width: 330px !important;margin:auto !important; }  */
.modal-footer{display: none;}
.feedback {
  background-color : #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}
 
.card-body {
    flex: 1 1 auto;
    padding: 1.25rem;
    padding-left: 1px;
    padding-right: 1px;
    padding-top: 0px;

}  

.pointer {cursor: pointer;}
</style>
 <script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'

const axios = require('axios')


export default {
  name: 'Cards',
  data: function () {
    return {
      sampelAddModal: false,
      addDesignModal: false,
      addCollection:false,
      updateCollection:false,
      show: true,
      isCollapsed: true,
      collection_list:[],
      //category_list:[],
      collection_title:'',
      Design_Name:'',
      Design_Id:'',

      url_path:'',
      collection_category:'',
      
      collection_subcategory:'',
      collection_Id_txt:'',
      collection_id_edit:0,
      collection_title_edit:'',
      items:[],
      bordered: true,
       categoryoptions: [
          { value: '1', text: 'Men' },
          { value: '2', text: 'Women' },
          { value: '3', text: 'Kids' },
          
        ],
        subcategoryoptions: [
          { value: '1', text: 'Accessories' },
          { value: '2', text: 'bottom Wear' },
         
          
        ],

        collection_brand:[
          { value: '375', text: 'Unlisted Plus' },
          { value: '621', text: 'Babyhug' },
         
          
        ],


        fields: ['Sr No', 'Collection Title', 'Brand', 'Category/Sub Category', 'Created Date'],
        items: [
          { DESIGN:'Kartik Tshirt', REQUESTED_SAMPLE: 'Prototype/Fit Sample', FACTORY: 'FC-One', STATUS: 'Approved' },
          { DESIGN:'Tiny Pink Polka Dress', REQUESTED_SAMPLE: 'Preproduction Sample', FACTORY: 'FC-One', STATUS: 'Approved' }
          ]

        
        

      
    }
  },
  created: function() {  
    
      var userData = localStorage.getItem('userData');
      if (userData) {
         var userInfo = JSON.parse(userData)
          
         this.getCollectionList(); 
          //this.Categorylist();         
         this.vendor_id = userInfo[0].vendor_id; 
      }
   
  },

  methods: {      

    /****** Function to Get ColectionList ********/
    getCollectionList: function () {

        this.isBusy = true;
      var userData = localStorage.getItem('userData');
      if (userData) {
           var userInfo = JSON.parse(userData)
            

           this.vendor_id = userInfo[0].vendor_id; 

        axios.post(`${CONSTANTS.API_URL}/getcollectionlist`,{})
        .then(response => {
          this.result = response.data
          if (this.result.returnmsg === 'Successful') {

            this.collection_list  = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
           this.collection_list =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })


      }       

       


    },
     /****** Function to Get Category List ********/
    // Categorylist: function () {

    //     this.isBusy = true;
    //     var userdata = localStorage.getItem('userData')
    //     var userInfo = JSON.parse(userdata);

       
    //     axios.post(`${CONSTANTS.API_URL}/getCategoryList`,{})
    //     .then(response => {
    //       this.result = response.data
    //       if (this.result.returnmsg === 'Successful') {

    //         this.category_list  = this.result.returnvalue;
    //         this.totalRows = this.result.returnvalue.length;
    //         this.isBusy = !this.isBusy;
            
    //       }else {
    //        this.category_list =[];
    //        this.totalRows=0;
    //          this.isBusy = !this.isBusy;
    //       }


    //     })
    //     .catch(e => {
    //       this.errors.push(e)
    //     })


    // },


     /****** Function to Add Collection ********/
    collectionForm (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          const collectionObj = {
            collection_title: this.collection_title
           
          }
            
          if (this.collection_title !== '' ) 
          {

            axios.post(`${CONSTANTS.API_URL}/addnewcollections`,collectionObj)
            .then(response => {
                if(response.data.returnmsg == 'Successful') {

                    // alert("New Collection Added Successfully.");
                     this.$fire({
                text:"New Collection Added Successfully.",
                type: "success",
                timer: 30000
                      })
                    this.addCollection=false;
                    this.getCollectionList();
                } else {
                  if (result.body.returnmsg === 'NoUserExists') {
                
                    this.showAlert=true
                    
                  }
                }
              })
          }
        }
      })
    },



     /****** Function to Update Collection ********/
    updateCollectionDetail (scope) {
    
      this.$validator.validateAll(scope).then((result) => {

        if (result) {
          const collectionObj = {
            collection_title: this.collection_title_edit,
            collection_id: this.collection_id_edit
           
          }
            
          if (this.collection_title_edit !== '' ) 
          {

            axios.post(`${CONSTANTS.API_URL}/updatecollections`,collectionObj)
            .then(response => {
                if(response.data.returnmsg == 'Successful') {

                    // alert("Collection Updated Successfully.");
                       this.$fire({
                text:"Collection Updated Successfully.",
                type: "success",
                timer: 30000
                      })
                    this.updateCollection=false;
                    this.getCollectionList();
                } else {
                  if (result.body.returnmsg === 'NoUserExists') {
                
                    this.showAlert=true
                    
                  }
                }
              })
          }
        }
      })
    },


     openCollectionModal(collection_id,collection_title) {
       
        this.updateCollection =true;
        this.collection_id_edit=collection_id;
        this.collection_title_edit=collection_title;

     },

     openDesignModal(collection_id) {
        this.addDesignModal =true;
        this.collection_id=collection_id;

     },


      /****** Function to Add Design ********/
      AddDesign (scope) {
      this.$validator.validateAll(scope).then((result) => {
      if (result) {
      const designObj = {
      design_title: this.Design_Name,
                  
        design_no : this.design_no,
      design_categoty_id  : this.collection_category,
      design_subcategoty_id   : this.collection_subcategory,
         is_delete:"0",
        //created_by:"shilpa.pillai@firstcry.com",
        //updated_by:"mukesh.sharma@Firstcry.com",
        collection_id:this.collection_id,
        image_path:this.url_path,


      }

      if (this.design_title !== '') {
      axios.post(`${CONSTANTS.API_URL}/addnewdesign`,designObj)
      .then(response => {
      if(response.data.returnmsg == 'Successful') {

          // alert("New Design Added Successfully.");
          this.$fire({
                text:"New Design Added Successfully.",
                type: "success",
                timer: 30000
                      })
          window.location.href ="collections";
      } else {
        if (result.body.returnmsg === 'NoUserExists') {

          this.showAlert=true
          
        }
      }
      })
      }
      }
      })
      },


  }


}
</script>




